import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid } from "@mui/material";
import { Textarea } from "@/components/elements/Textarea";
import { FormField } from "@/components/elements/FormField";
import { TCompanyForm } from "@/features/company/types/companyForm";

type TCompanyOtherInfoFormProps = {};
export const CompanyOtherInfoForm: FC<TCompanyOtherInfoFormProps> = () => {
  const methods = useFormContext<TCompanyForm>();
  const { control } = methods;

  return (
    <InnerBox title="その他（顧客未開示の情報）">
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="referralCompanyInfo">
            <Textarea />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="note">
            <Textarea />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
